import { motion } from "framer-motion";
import { Container, Typography, Box } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";
import ImageModal from "./ImageModal";

export default function Programa() {
    return (
        <Container maxWidth="md" sx={{ textAlign: "center", py: 10, bgcolor: "white", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <ImageModal src='https://escuela-bancaria.s3.us-east-2.amazonaws.com/dd240cc9-3a59-4d59-9212-a41ce5ac05a1.jpeg' alt='programa' />
        </Container>
    );
}
